/** ユーザ変更申請ステータス */
class AccountLock {
    /** アカウントロック */
    static LOCK = { code: "1", icon: "lock" };
    /** アカウントロック解除 */
    static ANLOCK = { code: "0", icon: "anLock" };
}
export { AccountLock };
